import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';
import { ReactSVG } from "react-svg";

import './Select.css';

class Select extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  /**
   * A <select> mindig a látható (alapértelmezett) opcióját jeleníti meg, de a formData csak akkor
   * tartalmazza ezt az értéket, ha a felhasználó változtat rajta. Ezért mount után, ha a formData-ban
   * még nincs érték, a feloldott alapértéket (value → default) bevezetjük a formData-ba, hogy beküldéskor is elmenjen.
   */
  componentDidMount() {
    const { formData } = this.parent.state;
    const ws_data = this.ws_data;
    const current = formData[ws_data.fieldname];

    if (current === undefined || current === '') {
      const fallback = (ws_data.value !== undefined && ws_data.value !== '') ? ws_data.value : ws_data.default;

      if (fallback !== undefined && fallback !== '') {
        this.parent.handle_change(null, ws_data.fieldname, { force_value: fallback });
      }
    }
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    let label = '';

    if (!!ws_data.label) {
      label =  <label className="field_label" dangerouslySetInnerHTML={{__html: ws_data.label + (ws_data.required ? ' *' : '')}}></label> ;
    }

    const conditionalProps = {};

    // aktuális érték meghatározása: formData (a Form a default-ból is feltölti) → ws_data.value → ws_data.default
    let selectedValue = formData[ws_data.fieldname];
    if (selectedValue === undefined || selectedValue === '') {
      selectedValue = (ws_data.value !== undefined && ws_data.value !== '') ? ws_data.value : ws_data.default;
    }

    return <div className="row">
      <div className={`field text ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>

        {label}

        <div className="select">
          <select
            id={ws_data.fieldname}
            defaultValue={selectedValue}
            onChange={(e) => parent.handle_change(e, ws_data.fieldname)}
            {...conditionalProps}
          >
            {!!ws_data.values ? Object.keys(ws_data.values).map((key) => <option key={key} value={key}>{ws_data.values[key]}</option>) : ''}
          </select> 
        </div>

        {parent.render_form_error(ws_data.fieldname)}
      </div>
    </div>; 
  }
};

export default Select;
